import { useState, useRef } from "react";
import axios from "axios";
import { useAuthContext } from "../../../hooks/useAuthContext";
import { ApiConnectionString } from "../../../constants/ApiConntection";
import LoadingSpinner from "../../../components/LoadingSpinner";

export default function UploadImageModal({ id, cancelModal }) {
  const [selectedFile, setSelectedFile] = useState(null);
  const { user } = useAuthContext();
  const [previewUrl, setPreviewUrl] = useState(null);
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setSelectedFile(file);
    if (file) {
      setPreviewUrl(URL.createObjectURL(file));
    } else {
      setPreviewUrl(null);
    }
  };

  const fileUploadHandler = async (e) => {
    e.preventDefault();
    if (!selectedFile) return;

    setIsLoading(true);

    const formData = new FormData();
    formData.append("image", selectedFile);

    try {
      const response = await axios.post(
        `${ApiConnectionString}/api/image/ClubImage/${id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.status === 200) {
        setUploadSuccess(true);
      }
    } catch (error) {
      console.error("Error uploading image:", error);
    } finally {
      setIsLoading(false);
      setSelectedFile(null);
      if (fileInputRef.current) {
        fileInputRef.current.value = null;
      }
    }
  };

  if (isLoading) {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          <LoadingSpinner />
          <div className="send-modal-footer"></div>
        </div>
      </div>
    );
  }

  if (uploadSuccess) {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          <div className="blueBanner">
            <p className="fw-bold m-2 p-2 fontSize20">Image Uploaded</p>
          </div>
          <p>Would you like to add another image?</p>
          <div className="send-modal-footer">
            <button
              className="saveChanges-button mx-3"
              onClick={() => {
                setUploadSuccess(false);
                setPreviewUrl(null);
                setSelectedFile(null);
                if (fileInputRef.current) {
                  fileInputRef.current.value = null;
                }
              }}
            >
              Yes
            </button>
            <button
              onClick={cancelModal}
              className="pointer cancelButton fw-bold mx-2 px-3"
            >
              No
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="send-modal-overlay">
      <div className="send-modal">
        <form>
          <div className="send-modal-content">
            <div className="blueBanner">
              <p className="fw-bold m-2 p-2 fontSize20">Upload Club Image</p>
              <button
                type="button"
                className="close-button"
                onClick={cancelModal}
                aria-label="Close"
              >
                &times;
              </button>
            </div>
            <div>
              <input
                type="file"
                onChange={handleFileChange}
                ref={fileInputRef}
              />
              <button
                onClick={fileUploadHandler}
                className="saveChanges-button"
                type="submit"
              >
                Upload
              </button>
            </div>
            {previewUrl && (
              <img
                src={previewUrl}
                alt="Image Preview"
                style={{ width: "100px", height: "100px" }}
              />
            )}
          </div>
          <div className="send-modal-footer">
            <button
              onClick={cancelModal}
              className="pointer cancelButton fw-bold mx-2 px-3"
              type="button"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
